// Helpers for assigning feature flags to installs.

interface FlagLike {
  flag_key?: unknown;
}

type FlagInput = string | FlagLike | null | undefined;

function keyOf(flag: FlagInput): string | null {
  if (typeof flag === 'string') return flag || null;
  const key = flag?.flag_key;
  return typeof key === 'string' && key ? key : null;
}

/**
 * Canonical flag keys that are not yet assigned to the install, deduplicated
 * in canonical order. Powers the "add flag" dropdown in Manage flags.
 */
export function availableFlagKeys(
  allFlags: FlagInput[] | null | undefined,
  installedFlags: FlagInput[] | null | undefined
): string[] {
  const installed = new Set<string>();
  for (const flag of installedFlags ?? []) {
    const key = keyOf(flag);
    if (key) installed.add(key);
  }
  const seen = new Set<string>();
  const out: string[] = [];
  for (const flag of allFlags ?? []) {
    const key = keyOf(flag);
    if (!key || installed.has(key) || seen.has(key)) continue;
    seen.add(key);
    out.push(key);
  }
  return out;
}
